import { schedularTherapistFilterAction } from 'src/redux/actions/constant';


const intialState: object = {
  response: null,
  isMinSplit: false,
  loading: false,
};

export const SplitTaskMinReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.SPLIT_TASK_MIN_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isMinSplit: true,
        loading: false,
      };
    }
    case  schedularTherapistFilterAction.SPLIT_TASK_MIN_FAILURE : {
      return {
        ...state,
        response: action.payload,
        isMinSplit: false,
        loading: false,
      };
    }

    case schedularTherapistFilterAction.SPLIT_TASK_MIN_LOADING:
      return {
        ...state,
        loading: true,
      };

    case schedularTherapistFilterAction.SPLIT_TASK_MIN_RESET:
      return intialState   


    default:
      return state;
  }
};
